export class FileAttribute {
	constructor(
		public attributeId?: String,
		public value?: String,
		public typeAttributeId?: String //document related
	) { }
}
